import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { DraftOrderListParams } from '../api/draft-orders-api';
import { DRAFT_ORDER_FILTER_FIELDS, DRAFT_ORDER_SORTS } from '../components/draft-order-filters';

/** URL search params of the draft orders list; mirrors GET /admin/v1/stores/{storeId}/draft-orders. */
export const draftOrderListSearchSchema = indexSearchSchema(DRAFT_ORDER_FILTER_FIELDS, {
  sort: DRAFT_ORDER_SORTS,
});

export type DraftOrderListSearch = z.infer<typeof draftOrderListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function draftOrderListParams(search: DraftOrderListSearch): DraftOrderListParams {
  return listParams(search, DRAFT_ORDER_FILTER_FIELDS);
}
